import { isLotItem } from '../whatnot/whatnotListingText';
import { matchesSearchText } from '../textNormalization';

function namesFrom(value) {
    return Array.isArray(value) ? value : (value ? [value] : []);
}

export function getPlayerNames(item) {
    if (isLotItem(item)) {
        return (item.cards ?? []).flatMap((card) => namesFrom(card.name));
    }
    return namesFrom(item?.name);
}

export function itemMatchesPlayerSearch(item, query) {
    const q = (query ?? '').trim();
    if (!q) return true;
    return getPlayerNames(item).some((name) => matchesSearchText(q, name));
}
